import {
  tr,
  Entity,
  IEntity,
  EntityUpdater,
  DialogService,
  NavigatorHelperBase,
  EntityFacade,
  Guard,
  BreadCrumbService,
} from '@kpd/framework-ngx';
import * as log from 'loglevel';

export class UserManagementEntityUpdater extends EntityUpdater {
  /**
   *
   */
  constructor(
    protected dialogService: DialogService,
    protected navigatorHelper: NavigatorHelperBase,
    protected facade: EntityFacade,
    protected guard: Guard,
    protected breadcrumbService: BreadCrumbService,
    private entityName: string,
  ) {
    super(dialogService, navigatorHelper, facade, guard, breadcrumbService);
  }

  beforeSave(entity: IEntity): void {
    log.info('save', entity);
    this.facade.detailLoadingStarted();
  }

  afterSave(_entity: IEntity, result: Entity, navigateAfterEdit: boolean, _uriEncodeKey: boolean): void {
    this.facade.detailLoadingFinished();
    this.changedItem$.next(result);
    if (navigateAfterEdit) {
      this.navigatorHelper.navigateToEdit(result.key, true, true);
    }
  }

  handleSaveError(error: any): boolean {
    this.facade.detailLoadingFinished();
    if (error.status === 409 && this.entityName !== 'users') {
      error = new Error(`Conflict: API returned 409 error`);
      this.error$.next(error);
      return true;
    } else {
      return false;
    }
  }

  handleDeleteError(error: any): void {
    if (error.status === 409 || error.status === 400) {
      this.error$.next(tr(`Cannot delete due to conflict(s)`) + ` : ${error.error}`);
    }
  }
}
